import { reducerRegistry } from '../../../../reducerRegistry';

import listsReducersMap from './lists/reducersMap';

const combineMap = {
  lists: listsReducersMap
};

export default function combineRegistry() {
  reducerRegistry.registerByCombineMap('userReferralModule', combineMap);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userReferral/reducers/static/combineRegistry.js